import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "inline-block relative text-12px xxl:text-14px" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_3 = { class: "text-gray-lp-300" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_5 = {
  key: 0,
  class: "text-red-lp-100"
}
const _hoisted_6 = {
  key: 0,
  class: "absolute z-50 mt-2 bg-white border border-gray-lp-400 rounded-md shadow",
  style: {"width":"320px"}
}
const _hoisted_7 = { class: "px-4" }
const _hoisted_8 = { class: "py-3 border-b border-gray-lp-400" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 mb-2" }, "Status Lokasi", -1)
const _hoisted_10 = { class: "py-3 border-b border-gray-lp-400" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 mb-2" }, "Tipe Kota", -1)
const _hoisted_12 = { class: "flex flex-col gap-y-2.5 py-1.5 w-full" }
const _hoisted_13 = { class: "py-3 border-b border-gray-lp-400 relative z-20" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 mb-2" }, "Status COD", -1)
const _hoisted_15 = { class: "py-3" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 mb-2" }, " Potensi Misbooking? ", -1)
const _hoisted_17 = { class: "flex flex-row gap-x-6" }
const _hoisted_18 = { class: "p-field-checkbox flex items-center" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", {
  for: "filter-district-misbooking-ya",
  class: "ml-2.5"
}, "Ya", -1)
const _hoisted_20 = { class: "p-field-checkbox flex items-center" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", {
  for: "filter-district-misbooking-tidak",
  class: "ml-2.5"
}, "Tidak", -1)
const _hoisted_22 = { class: "flex flex-row justify-between items-center px-4 py-3 border-t border-gray-lp-400" }
const _hoisted_23 = { class: "flex flex-row items-center gap-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "flex flex-row items-center gap-x-1 bg-white border border-gray-lp-400 rounded px-3 py-2.5 cursor-pointer",
      style: {"height":"40px"},
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePopover && _ctx.togglePopover(...args)))
    }, [
      (_openBlock(), _createBlock("svg", _hoisted_2, [
        _createVNode("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3.33334 2.5C3.01897 2.5 2.73135 2.67692 2.58957 2.9575C2.44779 3.23808 2.47597 3.57458 2.66246 3.82767L7.41228 10.2739V16.6667C7.41228 16.9705 7.57764 17.2502 7.84382 17.3967C8.11 17.5432 8.43481 17.5332 8.69149 17.3707L12.2003 15.1485C12.4415 14.9957 12.5877 14.73 12.5877 14.4444V10.2739L17.3376 3.82767C17.524 3.57458 17.5522 3.23808 17.4104 2.9575C17.2687 2.67692 16.981 2.5 16.6667 2.5H3.33334ZM8.9165 9.50567L4.9825 4.16667H15.0175L11.0835 9.50567C10.978 9.64888 10.9211 9.82211 10.9211 10V13.9858L9.07895 15.1525V10C9.07895 9.82211 9.02202 9.64888 8.9165 9.50567Z",
          fill: _ctx.hasActiveFilter ? '#B82025' : '#4D4D4D'
        }, null, 8, ["fill"])
      ])),
      _createVNode("span", _hoisted_3, [
        _hoisted_4,
        (_ctx.hasActiveFilter)
          ? (_openBlock(), _createBlock("span", _hoisted_5, "(" + _toDisplayString(_ctx.activeFilterCount) + ")", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_CustomDropdown, {
                modelValue: _ctx.localStatus,
                options: _ctx.statusOptions,
                selectedItem: _ctx.localStatus,
                value: _ctx.localStatus.name,
                placeholder: "Semua",
                class: "w-full custom-select",
                isCustomWidth: "",
                preventUnselect: "",
                onSelect: _ctx.onSelectStatus
              }, null, 8, ["modelValue", "options", "selectedItem", "value", "onSelect"])
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_CustomDropdown, {
                value: _ctx.typeDisplayValue,
                placeholder: "Semua",
                class: "w-full custom-select",
                isCustomWidth: ""
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_12, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeOptions, (option) => {
                      return (_openBlock(), _createBlock("div", {
                        key: option.value,
                        class: "p-field-checkbox flex items-center"
                      }, [
                        _createVNode(_component_Checkbox, {
                          id: `filter-district-type-${option.value}`,
                          name: "type",
                          value: option.value,
                          modelValue: _ctx.localType,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.localType = $event))
                        }, null, 8, ["id", "value", "modelValue"]),
                        _createVNode("label", {
                          for: `filter-district-type-${option.value}`,
                          class: "ml-2.5 cursor-pointer"
                        }, _toDisplayString(option.name), 9, ["for"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_CustomDropdown, {
                modelValue: _ctx.localIsCod,
                options: _ctx.codOptions,
                selectedItem: _ctx.localIsCod,
                value: _ctx.localIsCod.name,
                placeholder: "Semua",
                class: "w-full custom-select",
                isCustomWidth: "",
                preventUnselect: "",
                onSelect: _ctx.onSelectCod
              }, null, 8, ["modelValue", "options", "selectedItem", "value", "onSelect"])
            ]),
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode(_component_Checkbox, {
                    id: "filter-district-misbooking-ya",
                    binary: true,
                    modelValue: _ctx.localMisbookingYes,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.localMisbookingYes = $event)),
                    onChange: _ctx.onChangeMisbookingYes
                  }, null, 8, ["modelValue", "onChange"]),
                  _hoisted_19
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode(_component_Checkbox, {
                    id: "filter-district-misbooking-tidak",
                    binary: true,
                    modelValue: _ctx.localMisbookingNo,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.localMisbookingNo = $event)),
                    onChange: _ctx.onChangeMisbookingNo
                  }, null, 8, ["modelValue", "onChange"]),
                  _hoisted_21
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode("button", {
              type: "button",
              class: "text-red-lp-100 font-semibold cursor-pointer text-12px xxl:text-14px hover:underline focus:outline-none",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
            }, " Reset "),
            _createVNode("div", _hoisted_23, [
              _createVNode(_component_LpButton, {
                color: "white",
                textColor: "black-lp-300",
                title: "Batalkan",
                outline: "",
                customClass: "border border-gray-lp-400",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"]),
              _createVNode(_component_LpButton, {
                color: "red-lp-100",
                textColor: "white",
                title: "Simpan",
                onClick: _ctx.onApply
              }, null, 8, ["onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, _ctx.closePopover]
  ])
}